/** @format */

import MainHeader from '../Components/MainHeader';
import BoardItem from '../Components/BoardItem';
import BoardRadiobutton from '../Components/BoardRadiobutton';
import { useNavigate } from 'react-router-dom';
import { useState, useEffect } from 'react';
import Pagination from 'react-js-pagination';
import { useMediaQuery } from 'react-responsive';
import './FreeBoard.css';

const FreeBoard = () => {
  let rawListInfo = {};
  const [listInfo, setListInfo] = useState([]);
  const navigate = useNavigate();
  const parentFunction = (x) => {};

  const [page, setPage] = useState('1');
  const handlePageChange = (page) => {
    setPage(String(page));
    console.log(page);
  };

  const isPc = useMediaQuery({
    query: '(min-width: 768px)',
  });

  const fetList = async () => {
    const OPEN_API_DOMAIN = 'http://yapyap.r-e.kr:8090/';
    const board = 'free';
    const PageNum = page;
    const rawReasponse = await fetch(
      `${OPEN_API_DOMAIN}getPostList?board=${board}&pageNum=${PageNum}`
    );
    const jsonResponse = await rawReasponse.json();
    return jsonResponse;
  };

  useEffect(() => {
    rawListInfo = fetList();
    rawListInfo.then((value) => setListInfo(value));
  }, [page]);

  console.log(listInfo);

  return (
    <div>
      <MainHeader parentFunction={parentFunction} />
      <div className="freeBoard">
        <div className="freeBoardpageLeft"></div>
        <div className="freeBoardBoardList">
          {isPc ? (
            <div className="BoardSub">
              <div className="BoardNum">번호</div>
              <div className="BoardTittle">제목</div>
              <div className="BoardAuthor">글쓴이</div>
              <div className="BoardDate">작성일</div>
              <div className="BoardComment">댓글</div>
            </div>
          ) : null}
          <div>
            <div className="freeBoardpageBody">
              {listInfo.map((it) => (
                <BoardItem
                  key={it.postId}
                  {...it}
                />
              ))}
            </div>
            <button
              className="WriteButton"
              onClick={() => {
                navigate('/BoardEdit');
              }}>
              글 작성
            </button>
          </div>
          <div className="BoardSearchBox">
            <BoardRadiobutton />
            <input></input>
            <button>검색</button>
          </div>
          <Pagination
            activePage={page}
            itemsCountPerPage={10}
            totalItemsCount={50}
            pageRangeDisplayed={5}
            prevPageText="‹"
            nextPageText="›"
            onChange={handlePageChange}
          />
        </div>
        <div className="freeBoardpageRight"></div>
      </div>
    </div>
  );
};

export default FreeBoard;
